/**
 * Do not edit directly
 * Generated on Tue, 04 Jul 2023 13:44:41 GMT
 */

export const Typography = {
  label: {
    extraLarge: {
      normal:
        "font-family: Shell Font; font-weight: 400; font-size: 20px; line-height: 24px; letter-spacing: 0em; font-style: normal;",
      demi: "font-family: Shell Font; font-weight: 600; font-size: 20px; line-height: 24px; letter-spacing: 0em; font-style: normal;",
    },
    large: {
      normal:
        "font-weight: 400; font-size: 16px; line-height: 20px; letter-spacing: 0em; font-style: normal;",
      bold: "font-weight: 600; font-size: 16px; line-height: 20px; letter-spacing: 0em; font-style: normal;",
    },
    medium: {
      normal:
        "font-weight: 400; font-size: 14px; line-height: 16px; letter-spacing: 0em; font-style: normal;",
      bold: "font-weight: 600; font-size: 14px; line-height: 16px; letter-spacing: 0em; font-style: normal;",
    },
    small: {
      normal:
        "font-weight: 400; font-size: 11px; line-height: 16px; letter-spacing: 0em; font-style: normal;",
      bold: "font-weight: 600; font-size: 11px; line-height: 16px; letter-spacing: 0em; font-style: normal;",
    },
    extraSmall: {
      normal:
        "font-weight: 400; font-size: 10px; line-height: 12px; letter-spacing: 0em; font-style: normal;",
      bold: "font-weight: 600; font-size: 10px; line-height: 12px; letter-spacing: 0em; font-style: normal;",
    },
  },
  paragraph: {
    extraLarge: {
      normal:
        "font-family: Shell Font; font-weight: 400; font-size: 24px; line-height: 32px; letter-spacing: 0em; font-style: normal;",
      italic:
        "font-family: Shell Font; font-weight: 400; font-size: 24px; line-height: 32px; letter-spacing: 0em; font-style: italic;",
      bold: "font-family: Shell Font; font-weight: 700; font-size: 24px; line-height: 32px; letter-spacing: 0em; font-style: normal;",
    },
    large: {
      normal:
        "font-family: Shell Font; font-weight: 400; font-size: 20px; line-height: 28px; letter-spacing: 0em; font-style: normal;",
      italic:
        "font-family: Shell Font; font-weight: 400; font-size: 20px; line-height: 28px; letter-spacing: 0em; font-style: italic;",
      bold: "font-family: Shell Font; font-weight: 700; font-size: 20px; line-height: 28px; letter-spacing: 0em; font-style: normal;",
    },
    medium: {
      normal:
        "font-weight: 400; font-size: 16px; line-height: 24px; letter-spacing: 0em; font-style: normal;",
      italic:
        "font-weight: 400; font-size: 16px; line-height: 24px; letter-spacing: 0em; font-style: italic;",
      bold: "font-weight: 600; font-size: 16px; line-height: 24px; letter-spacing: 0em; font-style: normal;",
    },
    small: {
      normal:
        "font-weight: 400; font-size: 14px; line-height: 22px; letter-spacing: 0em; font-style: normal;",
      italic:
        "font-weight: 400; font-size: 14px; line-height: 22px; letter-spacing: 0em; font-style: italic;",
      bold: "font-weight: 600; font-size: 14px; line-height: 22px; letter-spacing: 0em; font-style: normal;",
    },
  },
  heading: {
    1: {
      normal:
        "font-family: Shell Font; font-weight: 400; font-size: 32px; line-height: 40px; letter-spacing: 0em; font-style: normal;",
      demi: "font-family: Shell Font; font-weight: 600; font-size: 32px; line-height: 40px; letter-spacing: 0em; font-style: normal;",
    },
    2: {
      normal:
        "font-family: Shell Font; font-weight: 400; font-size: 24px; line-height: 28px; letter-spacing: 0em; font-style: normal;",
      demi: "font-family: Shell Font; font-weight: 600; font-size: 24px; line-height: 28px; letter-spacing: 0em; font-style: normal;",
    },
    3: {
      normal:
        "font-family: Shell Font; font-weight: 400; font-size: 20px; line-height: 24px; letter-spacing: 0em; font-style: normal;",
      demi: "font-family: Shell Font; font-weight: 600; font-size: 20px; line-height: 24px; letter-spacing: 0em; font-style: normal;",
    },
    4: {
      normal:
        "font-weight: 400; font-size: 16px; line-height: 20px; letter-spacing: 0em; font-style: normal;",
      bold: "font-weight: 600; font-size: 16px; line-height: 20px; letter-spacing: 0em; font-style: normal;",
    },
    5: {
      normal:
        "font-weight: 400; font-size: 14px; line-height: 16px; letter-spacing: 0em; font-style: normal;",
      bold: "font-weight: 600; font-size: 14px; line-height: 16px; letter-spacing: 0em; font-style: normal;",
    },
  },
  display: {
    1: {
      normal:
        "font-family: Shell Font; font-weight: 400; font-size: 60px; line-height: 68px; letter-spacing: -0.02em; font-style: normal;",
      demi: "font-family: Shell Font; font-weight: 600; font-size: 60px; line-height: 68px; letter-spacing: -0.02em; font-style: normal;",
      bold: "font-family: Shell Font; font-weight: 700; font-size: 60px; line-height: 68px; letter-spacing: -0.02em; font-style: normal;",
    },
    2: {
      normal:
        "font-family: Shell Font; font-weight: 400; font-size: 52px; line-height: 60px; letter-spacing: -0.02em; font-style: normal;",
      demi: "font-family: Shell Font; font-weight: 600; font-size: 52px; line-height: 60px; letter-spacing: -0.02em; font-style: normal;",
      bold: "font-family: Shell Font; font-weight: 700; font-size: 52px; line-height: 60px; letter-spacing: -0.02em; font-style: normal;",
    },
    3: {
      normal:
        "font-family: Shell Font; font-weight: 400; font-size: 44px; line-height: 48px; letter-spacing: -0.02em; font-style: normal;",
      demi: "font-family: Shell Font; font-weight: 600; font-size: 44px; line-height: 48px; letter-spacing: -0.02em; font-style: normal;",
      bold: "font-family: Shell Font; font-weight: 700; font-size: 44px; line-height: 48px; letter-spacing: -0.02em; font-style: normal;",
    },
    4: {
      normal:
        "font-family: Shell Font; font-weight: 400; font-size: 36px; line-height: 44px; letter-spacing: 0em; font-style: normal;",
      demi: "font-family: Shell Font; font-weight: 600; font-size: 36px; line-height: 44px; letter-spacing: 0em; font-style: normal;",
      bold: "font-family: Shell Font; font-weight: 700; font-size: 36px; line-height: 44px; letter-spacing: 0em; font-style: normal;",
    },
  },
};
